import { EditorPlugin } from 'roosterjs-editor-core';
import { PluginKey } from '../store/schema/IEditorPlugins';
import ExcludedPlugins from '../store/schema/ExcludedPlugins';

const PluginKeyOrder: PluginKey[] = [
    'dockingPlugin',
    'dictationPlugin',
    'ribbonPlugin',
    'inlineImagePlugin',
    'inlineImageResizePlugin',
    'contentOperationPlugin',
    'tableEdit',
    'smartSuggestionsPlugin',
    'linkPreviewPlugin',
    'addinPlugin',
    'accCheckerPlugin',
    'pasteOptionPlugin',
    'linkPlugin',
    'mentionsPickerPlugin',
    'cortanaComposePlugin',
    'emojiPickerPlugin',
    'smartComposePlugin',
    'praguePlugin',
    'augLoopPlugin',
];

export default function getPluginArray<TExcluded extends PluginKey>(
    plugins: ExcludedPlugins<TExcluded>
): EditorPlugin[] {
    const includedKeys = Object.keys(plugins);
    const orderedkeys = PluginKeyOrder.filter(key => includedKeys.indexOf(key) >= 0);
    return orderedkeys.map(key => plugins[key]);
}
